<template>
  <div id="app">
    <AGWAudio :file="music.file" :loop="music.loop" :autoplay="music.autoplay"/>
    <AGWHero overlay :background="backgrounds" ref="hero" parallax target="#intro"/>

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro"/>

      <div class="pad-y-60">
        <AGWPawiwahan id="pawiwahan"/>
        <AGWMepandes id="mepandes" class="mar-top-60" :mepandes="mepandes"/>
      </div>

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="pad-y-60"/>
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3945.655185501755!2d115.20363731478315!3d-8.532816993866!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwMzEnNTguMSJTIDExNcKwMTInMjEuMCJF!5e0!3m2!1sen!2sid!4v1584623257283!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//-8.532817,115.205826/@-8.532817,115.2036373,17z/data=!4m2!4m1!3e0"
        :location="location"
        :time="time"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <div :style="{ 'height' : `${$root.dividerHeight}px` }"></div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height"/>
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 = 'https://ik.imagekit.io/aryraditya/agus-sri/SKF_7668_y9iTY-esH.jpg?tr=w-1200'
const ImageHero2 = 'https://ik.imagekit.io/aryraditya/agus-sri/RDS06579_Y6-i5_5kL.jpg?tr=w-1200'
const ImageHero3 = 'https://ik.imagekit.io/aryraditya/agus-sri/SKF_7570_vQxkjqe7e.jpg?tr=w-1200'
const ImageHero4 = 'https://ik.imagekit.io/aryraditya/agus-sri/RDS06586_yWfiONrfg.jpg?tr=w-1200'

import Audio from "@/assets/audio/all-of-the-above.mp3";

import AGWHero from "@/components/Hero";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance
  },
  data() {
    return {
      title: 'Pawiwahan',
      backgrounds: [ImageHero1, ImageHero2, ImageHero3, ImageHero4],
      bgActive: 0,
      dividerHeight: 0,
      wedding: {
        man: {
          name: 'Komang Agus Rika Putra, SH',
          surname: 'Agus',
          parents: 'I Ketut Raka, S.Sos & Ni Wayan Sandat, S.Ag',
          description: 'Putra ketiga',
          address: 'Br. Banjaran, Ds. Abiansemal - Badung',
          photo: 'https://ik.imagekit.io/aryraditya/agus-sri/SKF_7607_MpvNuc2oQt.jpg?tr=w-400',
        },
        woman: {
          name: 'Ni Komang Sri Arvina, Amd. Keb',
          surname: 'Arvina',
          description: 'Putri ketiga',
          parents: 'I Wayan Budiarta & Ni Nyoman Suarti',
          address: 'Br. Pabean, Ketewel, Gianyar',
          photo: 'https://ik.imagekit.io/aryraditya/agus-sri/SKF_7541_O_AtnSk5S.jpg?tr=w-400',
        },
      },
      location: "Br. Banjaran, Desa Abiansemal - Badung",
      time: {
        start: this.$moment("2020-04-02 12:00"),
        end: "Selesai"
      },
      mepandes: [
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // if(navigator.serviceWorker) {
    //   navigator.serviceWorker.addEventListener("controllerchange", () => {
    //   if (this.sw.refreshing) return;
    //   // this.sw.refreshing = true;
    //   // window.location.reload();
    // });
    // }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
      this.sw.refreshing = true;
      window.location.reload();
    }
  }
};
</script>
